import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';
import { cx } from '../lib/cx';
import { Icon } from '../icons/Icon';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
  /** Convenience — render options from data instead of children. */
  options?: SelectOption[];
  placeholder?: string;
}

/** Native <select> styled with a chevron adornment (keeps native a11y + mobile UX). */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid, options, placeholder, className, children, ...rest },
  ref,
) {
  return (
    <span className="tc-select-wrap">
      <select ref={ref} className={cx('tc-select', invalid && 'tc-select--invalid', className)} {...rest}>
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options
          ? options.map((o) => (
              <option key={o.value} value={o.value} disabled={o.disabled}>
                {o.label}
              </option>
            ))
          : children}
      </select>
      <span className="tc-select-wrap__chevron" aria-hidden>
        <Icon name="chevron-down" size={18} />
      </span>
    </span>
  );
});
